module.exports = __webpack_public_path__ + "img/mobile-24.c5cac604.png";